import PropTypes from 'prop-types';
import React from 'react';
import cx from 'classnames';
import performSearchAction from '../action/performSearch';

class SearchBox extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      text: props.text,
      focused: false
    };
  }

  componentWillReceiveProps(newProps) {
    if (newProps.text && this.state.text !== newProps.text) {
      this.setState({ text: newProps.text });
    }
  }

  handleFocusChanged(focused) {
    this.setState({ focused });
    if (focused) this.refs.input.select();
  }

  handleTextChange(evt) {
    this.setState({ text: evt.target.value });
  }

  handleSubmit(evt) {
    evt.preventDefault();
    this.refs.input.blur();
    const query = this.state.text;
    this.context.executeAction(performSearchAction, { query });
  }

  render() {
    const { placeholder, className } = this.props;
    const { text, focused } = this.state;

    return (
      <div className={cx(
        'form-group',
        'search-control',
        focused ? 'focused' : '',
        className || ''
        )}
      >
        <form
          id="search"
          role="search"
          className="search-form"
          autoComplete="off"
          onSubmit={this.handleSubmit.bind(this)}
        >
          <div>
            <i
              className="icon-budicon-489"
              onClick={this.handleFocusChanged.bind(this, true)}
            />
            <input
              id="search-input"
              ref="input"
              className="search-input form-control"
              type="text"
              placeholder={placeholder}
              value={text}
              onChange={this.handleTextChange.bind(this)}
              onFocus={this.handleFocusChanged.bind(this, true)}
              onBlur={this.handleFocusChanged.bind(this, false)}
            />
          </div>
        </form>
      </div>
    );
  }
}

SearchBox.contextTypes = {
  executeAction: PropTypes.func
};

SearchBox.defaultProps = {
  className: '',
  placeholder: 'Search for docs',
  text: ''
};

SearchBox.propTypes = {
  className: PropTypes.string,
  placeholder: PropTypes.string,
  text: PropTypes.string
};

export default SearchBox;
